/**
 * 合同模板
 */
import React from 'react';
import styles from './index.module.scss';
import { XOKButton, XCancelButton, XSelect, } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message, } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import TempModal from './modal/TempModal';
import PDF from './modal/PDF';
import model from '@/reducers/contract/templatetrac/model';
import { setBreadcrumbPaths } from '@/reducers/home/actions';



class Template extends React.PureComponent {

    state = {
        tempName: {},//模板名称下拉
        currentOpenMode: '', // 当前需要打开的弹窗
        openModeParam: {}, // 当前需要打开的弹窗的入参
    }

    componentDidMount() {
        const { setBreadcrumbPaths, match, getTemptracName } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
        getTemptracName({ enumName: 'FadadaContractCodeEnum' });//模板名称
    }

    // 上传模板
    _createTemplate = () => {
        this.setState({
            currentOpenMode: 'creat'
        });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, tempName } = this.state;
        const { getTemptracList, } = this.props;
        this.searchCache = {
            code: tempName.code,//模板名称
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        getTemptracList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ tempName: {}, }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 表格操作  
    _tableAction = (item, type, value) => {
        const { history } = this.props;
        switch (type) {
            case 'pdf':
                // this.setState({
                //     currentOpenMode: 'pdf',
                //     openModeParam: value.url
                // });
                if (value.url) {
                    const regular = /(http|https):\/\/([\w.]+\/?)\S*/;
                    regular.test(value.url) ? window.open(value.url) : message.warning('路径无效');
                } else {
                    message.warning('暂无数据');
                }
                break;
            case 'temp':
                history.push({
                    pathname: '/home/contract/templatetrac/list/' + item,
                });
                break;
        }
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'creat'://上传模板
                return <TempModal title='上传模板' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            case 'pdf'://查看模板
                return <PDF title='查看模板' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this.props.getTemptracList(this.searchCache);// 列表查询方法
        }
    }

    render() {
        const { tempName, } = this.state;
        const { temptracList, temptracName } = this.props;

        return (

            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XSelect
                                label='模板名称'
                                placeholder='请选择'
                                renderData={temptracName}
                                dataIndex='value'
                                keyIndex='code'
                                value={tempName.value}
                                bindThis={this}
                                bindName='tempName'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: 'auto' }} label='上传模板' onClick={this._createTemplate} />
                    </div>
                    <TableContent
                        renderData={temptracList}
                        tableAction={this._tableAction}
                    />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Template.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息

    temptracList: PropTypes.array,
    getTemptracList: PropTypes.func,//列表数据(action)
    temptracName: PropTypes.array,
    getTemptracName: PropTypes.func,//模板名称下拉数据(action)
};

const mapStateToProps = (state) => {
    return {
        temptracList: state.templatetrac.temptracList,
        temptracName: state.templatetrac.temptracName,
    };
};
export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Template);
